import ComponentManager from "./ComponentManager";
import ComponentOptions, {ComponentOptionsInterface, ComponentOptionsValuePlaceholder} from "./ComponentOptions";

export default ComponentManager;
export {ComponentOptions, ComponentOptionsInterface, ComponentOptionsValuePlaceholder};
